<template>
<loader v-bind="{ loading }">
  <page-navigation title="New Team" />   
  
  <columns>
    <column>
      <p>Teams allow you to assign developers or members of staff to applications. Each assigned member is assigned a set of permissions by the account admin.</p>
    </column>
  </columns>

  <div class="box">
    <form>
      <columns>
        <column class="is-6">
          <text-input
            classes="is-medium"
            required
            :error="$root.errorBag.name"
            :value="team.name"
            @input="updateName">
            Name
          </text-input>
        </column>
        <column class="is-6">
          <data-selector
            multiple
            searchable
            classes="is-medium"
            required
            :items="availableApps"
            value-key="id"
            label-key="name"
            :error="$root.errorBag.apps"
            :value="team.apps">
            Apps
          </data-selector>
        </column>
      </columns>
      <columns>
        <column>
          <submit-button @submit="createTeam" :working="working">Create Team</submit-button>
        </column>
      </columns>
    </form>
  </div>
</loader>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { loadAppList } from '@/api/app'

export default {
  
  data: () => ({
    loading: true,
    working: false,
    apps: []
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'New Team')
    try {
      loadAppList(({data}) => {
        this.apps = data 
        this.loading = false
      }, error => this.loading = false)
    } catch (e) {
      console.log(e)
    }
  },

  methods: {
    ...mapMutations('team', [
      'updateName'
    ]),
    createTeam() {
      this.working = true
      this.$store.dispatch('team/createTeam').then(team => {
        this.$toast.success('Team created')
        this.working = false
        this.$router.push({
          name: 'team-manager',
          params: {
            team: team.id
          }
        })
      }).catch(error => {
        this.working = false
      })
    }
  },

  computed: {
    ...mapGetters('team', [
      'team'
    ]),
    availableApps() {
      return this.apps.filter(app => !app.team_id)
    }
  }
}
</script>